import { combineReducers } from '@reduxjs/toolkit';
import designReducer from '../features/design/designSlice';
import templateReducer from '../features/template/templateSlice'
import productReducer from '../features/product/productSlice'
import threeDReducer from '../features/threeD/threeDSlice'
const rootReducer = combineReducers({
    design: designReducer,
    product: productReducer,
    template: templateReducer,
    threeD: threeDReducer,
});

export default rootReducer;
